import { computed } from 'vue';

import { PRICE_FILTER_ID } from '@/store/consts';

function facetValuesMap(facet) {
  const valuesActive = facet.values?.filter((it) => !!it.selected) || [];

  if (facet.id === PRICE_FILTER_ID) {
    return valuesActive.length ? [String(valuesActive[0].from), String(valuesActive[0].to)] : [];
  }

  return valuesActive.map((it) => it.label || it.value).map((v) => String(v));
}

export function usePersEventCatalogData({ router, store, adaptive }) {
  const PRODUCTS_COUNT = computed(() => store.getters['category/productsCount']);
  const PRODUCTS_FILTERS = computed(() => store.getters['category/filters']);
  const PRODUCTS_SORT = computed(() => store.getters['category/sort']);

  const searchData = computed(() => ({
    query: router.currentRoute.value.query.text,
    queryFixed: router.currentRoute.value.query.text,
    resultsTotal: PRODUCTS_COUNT.value,
  }));

  const filtersData = computed(() => PRODUCTS_FILTERS.value.filter((it) => !!it.selected).map((filter) => ({
    type: filter.displayType,
    name: filter.name,
    values: facetValuesMap(filter),
  })));

  const listingData = computed(() => ({
    totalElements: PRODUCTS_COUNT.value,
    sort: PRODUCTS_SORT.value,
    elementsInRow: adaptive.isMobile ? 2 : 4,
  }));

  return {
    searchData,
    filtersData,
    listingData,
  };
}
